import React, { createContext, useContext, ReactNode } from 'react';
import ApiClient from '../../lib/api-client';
import { IAssignmentFileDTO } from '@common-frontend-submodule/interfaces/assignment-file/iassignment-file.interface';
import { IAssignmentFileCreationDTO } from '@common-frontend-submodule/interfaces/assignment-file/iassignment-file-creation.interface';
import { IApiResponseGenericDTO } from '@common-frontend-submodule/interfaces/common/iapi-response.interface';
import { AssignmentFileRoutes } from '@common-frontend-submodule/enums/routes/assignment-file-routes.enum';

const apiClient = ApiClient.getInstance()

interface AssignmentFileContextProps {
  getById: (assignmentFileId: string) => Promise<IApiResponseGenericDTO<IAssignmentFileDTO>>;
  getAll: (assignmentId: string) => Promise<IApiResponseGenericDTO<IAssignmentFileDTO[]>>;
  delete: (assignmentFileId: string) => Promise<IApiResponseGenericDTO<boolean>>;
  create: (file: File, model: IAssignmentFileCreationDTO) => Promise<IApiResponseGenericDTO<IAssignmentFileDTO>>;
}

const AssignmentFileContext = createContext<AssignmentFileContextProps | undefined>(undefined);

export const AssignmentFileProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const getById = async (assignmentFileId: string): Promise<IApiResponseGenericDTO<IAssignmentFileDTO>> => {
    return await apiClient.getRequest<IAssignmentFileDTO>(`${AssignmentFileRoutes.BasePrefix}/${assignmentFileId}`);
  };

  const getAll = async (assignmentId: string): Promise<IApiResponseGenericDTO<IAssignmentFileDTO[]>> => {
    return await apiClient.getRequest<IAssignmentFileDTO[]>(`${AssignmentFileRoutes.BasePrefix}/all/${assignmentId}`);
  };

  const create = async (file: File, model: IAssignmentFileCreationDTO): Promise<IApiResponseGenericDTO<IAssignmentFileDTO>> => {
    const formData = new FormData();

    formData.append('file', file);

    Object.entries(model).forEach(([key, value]) => {
      formData.append(key, value as string); // Преобразуем значение в строку
    });
  
    return await apiClient.postFormDataRequest<FormData, IAssignmentFileDTO>(
        AssignmentFileRoutes.BasePrefix,
      formData,
    );
  };

  const deleteAssignmentFile = async (assignmentFileId: string): Promise<IApiResponseGenericDTO<boolean>> => {
    return await apiClient.deleteRequest<null, boolean>(`${AssignmentFileRoutes.BasePrefix}/${assignmentFileId}`);
  };

  return (
    <AssignmentFileContext.Provider value={{ getById, getAll, create, delete: deleteAssignmentFile }}>
      {children}
    </AssignmentFileContext.Provider>
  );
};

export const useAssignmentFileStore = () => {
  const context = useContext(AssignmentFileContext);
  if (!context) {
    throw new Error('useAssignmentFileStore must be used within a AssignmentFileProvider');
  }
  return context;
};
